var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 49 38",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("path", {
          attrs: {
            d:
              "M44.615 13.002c2.087 0 3.779 1.677 3.779 3.745v18.498c0 2.068-1.692 3.745-3.779 3.745H3.778C1.69 38.99 0 37.313 0 35.245V16.747c0-2.068 1.69-3.745 3.777-3.745s3.779 1.677 3.779 3.745V31.5h33.28V16.747c0-2.068 1.691-3.745 3.778-3.745zM23.982 1.428c2.726 0 5.354.55 7.423 1.603 1.363.702 2.071 1.552 2.071 2.754 0 1.55-1.111 2.752-2.777 2.752-.506 0-1.06-.15-2.02-.6-1.517-.7-3.183-1.052-4.951-1.052-2.17 0-3.08.752-3.08 1.903 0 1.102.607 1.702 3.384 2.002l2.676.301c5.758.65 8.131 3.304 8.131 7.359 0 4.957-3.989 8.311-10.908 8.311-3.838 0-6.919-1.053-8.94-2.303-1.211-.751-1.717-1.653-1.717-2.804 0-1.551 1.314-2.803 2.93-2.803.655 0 1.262.2 2.07.652 1.767 1 3.637 1.751 6.01 1.751 2.576 0 3.79-.901 3.79-2.253 0-1.151-.658-1.753-3.536-2.053l-2.678-.3c-5.303-.6-7.98-3.204-7.98-7.41 0-4.755 3.687-7.81 10.102-7.81z",
            id: "strix-s-logo@3x_svg__a"
          }
        })
      ]),
      _c(
        "g",
        {
          attrs: {
            transform: "translate(0 -1)",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "mask",
            { attrs: { id: "strix-s-logo@3x_svg__b", fill: "#fff" } },
            [_c("use", { attrs: { "xlink:href": "#strix-s-logo@3x_svg__a" } })]
          ),
          _c("use", {
            attrs: { fill: "#808091", "xlink:href": "#strix-s-logo@3x_svg__a" }
          }),
          _c(
            "g",
            {
              attrs: { mask: "url(#strix-s-logo@3x_svg__b)", fill: "#D90077" }
            },
            [_c("path", { attrs: { d: "M0 40h49V0H0z" } })]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }